import React, { Component } from 'react';
import { formatDateWithPattern } from '../../../../utils/time/formatDateWithPattern';

class DateFormatter extends Component {
  render() {
    if (!this.props.value) {
      return null;
    }

    return <div>{formatDateWithPattern(this.props.value, 'DD MMMM YYYY')}</div>;
  }
}

export default DateFormatter;
